// The one photo a track leads with — on its tile, its curriculum hero and
// its link preview: the explicit cover an admin uploaded, falling back to
// the first item (in curriculum order) that has a cover.
export function trackCoverUrl(
  ownCover: string | null,
  itemCovers: ReadonlyArray<string | null>,
): string | null {
  return ownCover ?? itemCovers.find((c) => c !== null) ?? null;
}
